import { render } from "./ProjectActivity.vue?vue&type=template&id=74fa7f8e&scoped=true"
import script from "./ProjectActivity.vue?vue&type=script&lang=js"
export * from "./ProjectActivity.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-74fa7f8e"

export default script